<template>
  <v-dialog
    v-if="value"
    v-model="value"
    :width="modalDataSet.width || 'auto'"
    :max-width="modalDataSet.maxWidth || 'none'"
    :persistent="modalDataSet.isPersistent || false"
    :fullscreen="modalDataSet.isFullscreen || false"
    :hide-overlay="modalDataSet.hideOverlay || false"
    :scrollable="modalDataSet.isScrollable || false"
    :no-click-animation="modalDataSet.noClickAnimation || false"
    :transition="fromBottom ? 'dialog-bottom-transition' : ''"
  >
    <v-card class="pa-0">
      <v-progress-linear v-if="isNestedFemsLoading" :indeterminate="true"></v-progress-linear>
      <div :id="instanceId" :data-adacado-dataset="datasetObj">
        <div v-pre></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Parameter from 'parameter-mixin'
import FemsService from 'fems-service'

export default {
  name: 'modalWrapper',
  mixins: [Parameter],
  data() {
    return {
      isNestedFemsLoading: false,
      instanceId: undefined,
    }
  },
  props: {
    value: Boolean, // Parent using this component is expected to set/control v-model
    modalDataSet: {
      type: Object,
    },
    femsName: {
      type: String,
    },
    femsVersion: {
      type: String,
    },
    aEvents: {
      type: Array,
      default() {
        return []
      },
    },
    fromBottom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    datasetObj() {
      return this.$constructAdacadoDataset({
        //isNestedFemsLoadingEvent: `${this.instanceId}-loaded`,
        instanceId: this.instanceId,
        ...this.modalDataSet
      })
    },
  },
  watch: {
    // We're watching when the parent of this component changes the value
    // of the v-model attribute - this is Vue syntactic sugar
    value(isOpen) {
      if (isOpen) {
        this.isNestedFemsLoading = true
        this.instanceId = FemsService.generateInstanceId(this.femsName, this.femsVersion)

        // Update Instance Hooks for this child FEMS instance
        // See FEMS-Bootstrapper for more notes on Instance Hooks
        const isNestedFemsLoadingFunction = () => this.isNestedFemsLoading = false
        FemsService.addInstanceHook(this.instanceId, 'mounted', isNestedFemsLoadingFunction)

        // listen to events following the events list
        this.aEvents.forEach(event => {
          this.guibus_subscribe(event.eventName, payload => {
            // Note: `this` is the modalWrapperObj
            event.callback(this, payload)
          })
        })

        // Finally, invoke initialization/rendering of child fems
        this.$nextTick(() => {
          FemsService.renderChildFems(this.femsName, this.femsVersion, this.instanceId)
        })
      } else {
        // remove all hooks of an instanceId (unsubscribe all)
        FemsService.removeAllHooks(this.instanceId)

        // remove all listeners
        this.aEvents.forEach(event => {
          this.guibus_unsubscribe(event.eventName)
        })

        // Finally, invoke teardown of child fems
        this.$nextTick(() => {
          FemsService.teardownChildFems(this.femsName, this.femsVersion, this.instanceId)
        })
      }
    }
  },
}
</script>
